// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2RGGx","boxTitle":"Qualiphy_boxTitle__3CkQT","box":"Qualiphy_box__8u4N2","toggleWrap":"Qualiphy_toggleWrap__3zg1y"};